import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { withRouter } from '../../util/withRouter';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DropdownButton, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DatePicker } from './components/DatePicker';
import Filter from './components/ReportFilter';
import NoData from '../../components/NoData/NoData';
import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';
import Confirm from '../../components/Confirm/Confirm';

import {
  getFilters,
  setFilters,
  requestData,
  requestComparisonData,
  getPdf,
  getComparisonPdf,
  getCsv,
  selectStream,
  deleteStream,
  listAll,
  saveSelected,
  saveSelectedBreakdown,
  saveSelectedDateRange
} from './ReportActions';
import { saveFilterSize } from '../../components/Filter/FilterActions';
import Views from './components/ExecDashboardView/Views';
import ReportTable from './components/ReportTable/ReportTable';
import SaveView from './components/ExecDashboardView/SaveView';
import LineChart from './components/LineChart';
import ValueStreamSelector from './components/ValueStreamSelector';
import SubscribeEDAddOn from '../../components/SubscribeEDAddOn/SubscribeEDAddOn';

import exportIcon from '../../assets/img/download.svg';
import cloudDownload from '../../assets/images/cloud-download-icon.svg';
import settingsIcon from '../../assets/img/settings-icon.svg';
import createIcon from '../../assets/img/createDashboard-icon.svg';
import lineChartOnIcon from '../../assets/img/line-chart-icon-on.svg';

import dashboardIcon from '../../assets/img/dashboard.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/images/edit-blue.svg';
import saveIcon from '../../assets/images/save.svg';
import applyIcon from '../../assets/images/check-square-fill.svg';
import defaultBoardImg from '../../assets/images/stream-default-icon.jpg';

import expandIcon from '../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../assets/img/zoom-icon-on.svg';

import '../../util/moment-duration';
import { getBreakDownList, reportHasNoData, leavesFullScreen, cardIsEmpty } from '../../util/reportUtils';
import { ChartPlaceholder } from '../../components/CardViews/CardViews';

import { PieChartWidget } from './components/PieChartWidget';

import {
  trackExecutiveFilterChange,
  trackReportConfigChange,
  trackExecutiveDashboardView } from '../../util/mixpanel';

import { getStreamAccessRights } from '../../util/permissions';
import { GridStackManager } from '../../util/gridStackUtils';

import './Reports.scss';
import _ from 'lodash';
import { formatWorkDuration } from '../../util/dates';

function formatCycletimeLabel(point, excludeWeekendOpts, timePrecision) {
  const duration = formatWorkDuration(point.y, excludeWeekendOpts, timePrecision);
  return `(${duration}) ${(point.percentage || 0).toFixed(2)}%`;
}

function formatThroughputLabel(point) {
  return `${(point.percentage || 0).toFixed(2)}% (${point.y} ${point.y > 1 ? 'items' : 'item'})`;
}

const TRENDS_ROWS = { ctb: { row: 1 }, 'throughput-trends': { row: 1 }, wip: { row: 2 }, wipAge: { row: 2 } };
const DISTRIBUTION_ROWS = {
  cycletime: { row: 1 },
  throughput: { row: 1 },
  percentiles: { row: 2 },
  'percentile-trends': { row: 2 },
  'flow-efficiency': { row: 2 }
};

const COMPARISON_TEXT = {
  lastWeek: { labels: ["Period assessed", "Previous week", "Last 3 weeks", "Last 6 weeks"], subtitle: "Last completed week compared with the previous week and the last 3 and 6 weeks" },
  last2Week: { labels: ["Period assessed", "Previous 2 weeks", "Last 6 weeks", "Last 12 weeks"], subtitle: "Last 2 completed weeks compared with the previous 2 weeks and the last 6 and 12 weeks" },
  lastMonth: { labels: ["Period assessed", "Previous month", "Last 3 months", "Last 6 months"], subtitle: "Last completed month compared with the previous month and the last 3 and 6 months" },
  last3Month: { labels: ["Period assessed", "Previous quarter", "2 quarters ago", "3 quarters ago"], subtitle: "Last completed quarter compared with each of the previous 3 quarters" }
};

const DragIcon = ({ customizeMode }) => (
  <div className={`card-drag ${customizeMode ? '' : 'hidden'}`}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2v20" />
      <path d="m15 19-3 3-3-3" />
      <path d="m19 9 3 3-3 3" />
      <path d="M2 12h20" />
      <path d="m5 9-3 3 3 3" />
      <path d="m9 5 3-3 3 3" />
    </svg>
  </div>
);

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.trendsGridRef = React.createRef();
    this.distributionGridRef = React.createRef();
    this.gridManagers = [];
    this.state = {
      comparison: false,
      percentile: (props.filters && props.filters.percentile) || 85,
      threshold: (props.filters && props.filters.threshold) || 5,
      dateRange: props.dateRange || 'lastMonth',
      dateFormat: (props.filters && props.filters.dateFormat) || 'D/MM/YY',
      isFullScreen: '',
      cycletime: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      throughput: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      wip: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      wat: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      page: 1,
      th: false,
      wp: false,
      wat: false,
      ct: false,
      fe: false
    };
  }

  componentDidMount() {
    const isComparisonInitially = this.props.location.search && this.props.location.search.includes('comparison=true');
    const currentReportId = this.props.routeParams.id || this.props.selectedStream && this.props.selectedStream._id;

    this.setState({ comparison: isComparisonInitially });

    if (!this.trialExpired()) {
      if (isComparisonInitially) {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        }
      } else {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        }
      }
    }

    if (!isComparisonInitially) {
      this.initializeGridStack();
    }
  }

  async initializeGridStack() {
    const grids = [
      [this.trendsGridRef, TRENDS_ROWS],
      [this.distributionGridRef, DISTRIBUTION_ROWS]
    ].filter(([ref]) => ref.current);
    if (!grids.length) return;

    const managers = grids.map(([ref, rows]) => {
      const manager = new GridStackManager(ref, {
        cellHeight: 350,
        column: 12
      });
      manager.setWidgetConfig(rows);
      return manager;
    });
    this.gridManagers = managers;

    await Promise.all(managers.map(manager => manager.loadGridStack()));

    if (this.gridManagers === managers) {
      managers.forEach(manager => manager.triggerChartResize());
    }
  }

  componentWillUnmount() {
    this.gridManagers.forEach(manager => manager.destroy());
    this.gridManagers = [];
  }

componentDidUpdate(prevProps, prevState) {
  const prevStreamId = prevProps.selectedStream ? prevProps.selectedStream._id : undefined;
  const currentStreamId = this.props.selectedStream ? this.props.selectedStream._id : undefined;
  const currentReportContextId = this.props.routeParams.id || currentStreamId;
  const prevReportContextId = prevProps.routeParams.id || prevStreamId;
  const reportContextIdChanged = currentReportContextId !== prevReportContextId;

    const filtersChanged = !_.isEqual(prevProps.filters, this.props.filters);
    const locationSearchChanged = prevProps.location.search !== this.props.location.search;

    const fullScreen = this.state.isFullScreen;
    if (leavesFullScreen(fullScreen, this.props.trends, this.props.loading)) {
      this.setState({ isFullScreen: '' }, () => this.updateFontSize(fullScreen));
    }

    if (filtersChanged && this.props.filters) {
      const stateUpdates = {};
      if (this.props.filters.percentile !== undefined && this.props.filters.percentile !== this.state.percentile) {
        stateUpdates.percentile = this.props.filters.percentile;
      }
      if (this.props.filters.threshold !== undefined && this.props.filters.threshold !== this.state.threshold) {
        stateUpdates.threshold = this.props.filters.threshold;
      }
      if (Object.keys(stateUpdates).length > 0) {
        this.setState(stateUpdates);
      }
    }

    if (this.props.routeParams.id && !this.props.loading && _.findIndex(this.props.streams, { _id: this.props.routeParams.id }) === -1){
      this.props.router.push('/no-value-stream-permissions');
    }
    if (reportContextIdChanged && currentReportContextId) {
      this.props.getFilters(currentReportContextId);
    }

    if (locationSearchChanged) {
      const newIsComparisonFromUrl = this.props.location.search && this.props.location.search.includes('comparison=true');
      if (newIsComparisonFromUrl !== this.state.comparison) {
        if (newIsComparisonFromUrl && this.gridManagers.length) {
          this.gridManagers.forEach(manager => manager.cleanupWithoutDom());
          this.gridManagers = [];
        }
        this.setState({ comparison: newIsComparisonFromUrl }, () => {
          if (this.state.comparison) {
            this.getComparsion(currentStreamId);
          } else {
            if (currentReportContextId) this.props.requestData(currentReportContextId);
            this._syncBreakdownSettingsFromProps(this.props, prevProps);
            this.initializeGridStack();
          }
        });
      }
    }

  if (filtersChanged && this.props.filters && this.props.filters.name && !this.props.loading) {
    const statsUpdatedWithFilters = !_.isEqual(prevProps.stats, this.props.stats);
    if (!this.state.comparison) {
      const loaded = this._syncBreakdownSettingsFromProps(this.props, prevProps);
      if (currentReportContextId && !loaded && !statsUpdatedWithFilters) {
        this.props.requestData(currentReportContextId);
      }
    } else {
      this.getComparsion(currentStreamId);
    }
    }
    else if (reportContextIdChanged && this.props.filters && this.props.filters.name && !this.state.comparison) {
      this._syncBreakdownSettingsFromProps(this.props, prevProps);
    }
  }

  getBreakDownName(values) {
    const { filters } = this.props;
    let name;

    if (values.indexOf('labels') > -1) {
      switch (this.props.app) {
        case 'azure':
          return 'Work item types';
        case 'trello':
          return 'Labels';
        case 'asana':
          return 'Tags';
        case 'jira':
          return 'Priorities';
      }
    }

    if (values.indexOf('statuses') > -1) {
      switch (this.props.app) {
        case 'jira':
        case 'file':
          return 'Statuses';
        case 'azure':
          return 'Columns';
        case 'trello':
          return 'Lists';
        case 'asana':
          return 'Sections';
      }
    }

    _.some(values, value => {
      return _.some(filters.dashboards, dashboard => {
        const cf = _.find(dashboard.allCustomFields, { id: value });
        if (cf) {
          name = cf.name;
          return true;
        }
      });
    });
    return name;
  };

  updateFontSize = chart => {};

 getReport = (newDashboardFilters = this.props.filters.dashboards, triggerDataRefresh = true, updateFilters = false) => {
    const { threshold, percentile } = this.state;
    const { wallmode, selectedStream, routeParams, setFilters, requestData } = this.props;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!currentReportId) {
      return;
    }

    const bodyForSetFilters = {
      dashboards: newDashboardFilters,
      controls: { threshold, percentile }
    };

    if (!wallmode && selectedStream && updateFilters) {
      setFilters(currentReportId, bodyForSetFilters, true).then((result) => {
        if (this.state.comparison) {
          this.getComparsion(currentReportId);
        } else if (result && !result.hasData && !result.error) {
          requestData(currentReportId);
        }
      });
    } else if (triggerDataRefresh && !this.state.comparison) {
      requestData(currentReportId);
    }
  };

  applyFilters = (filters = {}, isInitial) => {
    this.getReport(filters, true, true);

    if(!isInitial){
      trackExecutiveFilterChange(this.getDashboardsNames(), 'filters');
    }
  }

  handleDateChange = dates => {
    const body = {
      dates: {
        startDate: dates.startDate.toISOString(),
        endDate: dates.endDate.toISOString(),
        customDate: dates.customDate,
        fixedStartDate: dates.fixedStartDate,
        dateDiff: dates.daysFromStart
      }
    };

    this.props.setFilters(this.props.selected._id, body, true).then((result) => {
      if (result && !result.hasData && !result.error) {
        this.props.requestData(this.props.selected._id);
      }
    });

    trackExecutiveFilterChange(this.getDashboardsNames(), 'period', body.dates);
  };

  handleConfigure = () => {
    this.props.router.push('/configure/'+  this.props.selected._id);
  };

  handleNew = () => {
    this.props.select({ isNew: true });
    this.props.router.push('/configure');
  };

  handlePdfExport = () => {
    if (this.state.comparison) {
      const { percentile, threshold } = this.state;
      this.props.getComparisonPdf(percentile, threshold, this.props.selected && this.props.selected._id);
      return;
    }
    this.props.getPdf(this.props.selected && this.props.selected._id);
  };

  handleCsvExport = () => {
    this.props.getCsv(this.props.selected && this.props.selected._id);
  }

  getComparsion = (currentStreamId) => {
    const { page } = this.state;
    this.props.requestComparisonData(page, currentStreamId);
  };

  changePercentile = value => {
    this.setState({ percentile: parseInt(value, 10) });

    trackReportConfigChange(this.getDashboardsNames(), 'ct_percentile', { percent: parseInt(value, 10) } );
  };

  changeThreshold = value => {
    this.setState({ threshold: value });

    trackReportConfigChange(this.getDashboardsNames(),'controls', { variation: value } );
  };

  changeDateRange = value => {
    this.setState({ dateRange: value });
    this.props.saveSelectedDateRange(this.props.selected._id, value);

    trackReportConfigChange(this.getDashboardsNames(), 'controls', { group_by: this.getGroupByValue(value) } );
  };

  getGroupByValue(value) {
    switch(value) {
      case 'lastWeek':
        return 'one_week';
      case 'last2Week':
        return 'two_weeks';
      case 'lastMonth':
        return 'month';
      case 'last3Month':
        return 'quarter';
      default:
        return value;
    }
  }

  getDashboardsNames() {
    return this.props.filters && this.props.filters.dashboards ?
      _.join(_.map(this.props.filters.dashboards, 'name')) : '';
  }

  toggleView = (comparison) => {
    if (!this.props.loading && (comparison !== this.state.comparison)){
      this.setState({ comparison });
      if (comparison) {
        this.getComparsion(this.props.routeParams.id);
      } else {
        this.props.requestData(this.props.routeParams.id);
      }
    }
  };

  compare(current, previous) {
    return Math.round((10000 * current) / previous) / 100 - 100;
  }

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getComparsion);
  };

  onBreakdownChange = (widget, field) => {
    const { selectedStream, saveSelectedBreakdown, wallmode } = this.props;
    const reportId = selectedStream && selectedStream._id;
    if (!reportId) {
      return;
    }
    if (!wallmode){
      saveSelectedBreakdown(reportId, widget, field.id);
    }
    trackExecutiveFilterChange(this.getDashboardsNames(), `${widget}_breakdown_by`, {
      breakdown_by: field.id === null ? '' : field.name
    });
  }

  handleChartExpand = (stateKey, cardId, trackingId) => {
    const newValue = !this.state[stateKey];
    this.setState({ [stateKey]: newValue }, () => {
      const card = document.getElementById(cardId);
      const manager = card && this.gridManagers.find(item => item.gridRef.current && item.gridRef.current.contains(card));
      if (manager) {
        manager.updateWidgetHeight(card, newValue ? 2 : 1);
      }
      this.trackChartDetailsView(trackingId, !newValue);
    });
  };

  handleResize = ev => {
    const chart = ev.target.id.split('-')[1];
    if (this.state.isFullScreen) {
      this.setState(
        { isFullScreen: '' },
        () => this.updateFontSize(chart)
      );
    } else {
      this.setState(
        { isFullScreen: chart },
        () => this.updateFontSize(chart)
      );

      trackExecutiveDashboardView(chart);
    }
  };

  trackChartDetailsView (chart, isHidden) {
    if (!isHidden) {
      trackExecutiveDashboardView(chart + '_details');
    }
  }

  fillComparisonValues = (getValue, threshold) => {
    const currentMonthValue = getValue(0);
    const values = [];
    values.push({ value: currentMonthValue });
    for (let j = 1; j < 4; j++) {
      if (currentMonthValue) {
        const cValue = getValue(j);
        const cComparison = this.compare(currentMonthValue, cValue);
        values.push({
          value: cValue,
          comparison: cComparison,
          active: Math.abs(cComparison) > threshold
        });
      } else {
        values.push({});
      }
    }
    return values;
  };

  convertReportDataItemToComparisonValues = (percentile, threshold, d, dashboard) => {
    const item = {
      name: dashboard.name,
      month: d.month,
      avgCycleTime: this.fillComparisonValues(
        i => _.find(d.comparison[i].cycleTime, { name: percentile }).value,
        threshold
      ),
      avgThroughput: this.fillComparisonValues(i => d.comparison[i].throughput, threshold),
      wipTrend: this.fillComparisonValues(i => d.comparison[i].wipTrend, threshold),
      wipAge: this.fillComparisonValues(i => d.comparison[i].wipAge, threshold),
      flowEfficiency: this.fillComparisonValues(i => d.comparison[i].flowEfficiency, threshold)
    };

    return item;
  };
_deriveBreakdownStateForWidget(widgetType, currentProps = this.props) {
    const { filters } = currentProps;
    const breakdownList = getBreakDownList(filters && filters.dashboards, widgetType);

    let defaultName = '';
    let defaultValue = [];

    if (breakdownList && breakdownList.length > 0) {
      defaultName = breakdownList[0].name;
      defaultValue = breakdownList[0].id;
    } else {
      return {
        ...this.state[widgetType],
        name: '', search: '', value: [],
      };
    }

    const selectedBreakdownIdsFromFilters = filters && filters[widgetType];
    let derivedName = defaultName;
    let derivedValue = defaultValue;

    if (selectedBreakdownIdsFromFilters && Array.isArray(selectedBreakdownIdsFromFilters) && selectedBreakdownIdsFromFilters.length > 0) {
      const nameFromFilterIds = this.getBreakDownName(selectedBreakdownIdsFromFilters);
      if (nameFromFilterIds) {
        const foundInList = breakdownList.find(item => item.name === nameFromFilterIds);
        if (foundInList) {
          derivedName = foundInList.name;
          derivedValue = foundInList.id;
        }
      }
    }

    return {
      ...this.state[widgetType],
      name: derivedName,
      search: derivedName,
      value: derivedValue,
    };
  }

 _syncBreakdownSettingsFromProps(propsToUse = this.props, prevProps = {}) {
    const { filters, selectedStream, routeParams, stats } = propsToUse;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!filters || !filters.name || !currentReportId) {
        return false;
    }

    const newCycleTimeState = this._deriveBreakdownStateForWidget('cycletime', propsToUse);
    const newThroughputState = this._deriveBreakdownStateForWidget('throughput', propsToUse);

    const stateToUpdate = {};
    let needsUiUpdateForBreakdownSelection = false;

    if (!_.isEqual(this.state.cycletime.name, newCycleTimeState.name) || !_.isEqual(this.state.cycletime.value, newCycleTimeState.value)) {
      stateToUpdate.cycletime = { ...this.state.cycletime, ...newCycleTimeState };
      needsUiUpdateForBreakdownSelection = true;
    }
    if (!_.isEqual(this.state.throughput.name, newThroughputState.name) || !_.isEqual(this.state.throughput.value, newThroughputState.value)) {
      stateToUpdate.throughput = { ...this.state.throughput, ...newThroughputState };
      needsUiUpdateForBreakdownSelection = true;
    }

    let criticalFiltersChanged = false;
    if (prevProps.filters) {
        const relevantCurrentFilters = {
            dashboards: filters.dashboards,
            controls: filters.controls,
            name: filters.name
        };
        const relevantPrevFilters = {
            dashboards: prevProps.filters.dashboards,
            controls: prevProps.filters.controls,
            name: prevProps.filters.name
        };
        function preprocessFilters(filters) {
          const clonedFilters = _.cloneDeep(filters); // Use Lodash's cloneDeep
          if (clonedFilters.dashboards && Array.isArray(clonedFilters.dashboards)) {
            clonedFilters.dashboards.forEach(dashboard => {
              if (dashboard.allMembers && Array.isArray(dashboard.allMembers)) {
                dashboard.allMembers.forEach(member => {
                  if (member && member._id === 'no-member' && member.value === 'no-member') {
                    delete member.label;
                  }
                });
              }
            });
          }
          return clonedFilters;
        }

        const processedCurrentFilters = preprocessFilters(relevantCurrentFilters);
        const processedPrevFilters = preprocessFilters(relevantPrevFilters);
        if (!_.isEqual(processedCurrentFilters, processedPrevFilters)) {
            criticalFiltersChanged = true;
        }
    } else {
        criticalFiltersChanged = true;
    }

    const statsUpdatedWithFilters = prevProps.stats && !_.isEqual(prevProps.stats, stats);
    let willRefreshData = false;

    if (needsUiUpdateForBreakdownSelection) {
      if (criticalFiltersChanged && !statsUpdatedWithFilters) {
        willRefreshData = true;
        this.setState(stateToUpdate, () => {
          if (!this.state.comparison) {
            this.getReport(filters.dashboards, true);
          }
        });
      } else {
        this.setState(stateToUpdate);
      }
    } else if (!this.state.comparison && criticalFiltersChanged && !statsUpdatedWithFilters) {
      willRefreshData = true;
      this.getReport(filters.dashboards, true);
    }

    return willRefreshData;
}

deleteStream() {
  this.props.remove(this.props.selected._id);
  if (this.state.comparison) {
    this.props.router.push('/report?comparison=true');
  } else {
    this.props.router.push('/report');
  }
}

  renderComparisonReport() {
    const { percentile, threshold, dateRange } = this.state;
    const { comparisons, wallmode } = this.props;
    const comparison = comparisons && comparisons[dateRange] && comparisons[dateRange].data;
    const comparisonDates = comparisons && comparisons[dateRange] && comparisons[dateRange].dates;
    const comparisonText = COMPARISON_TEXT[dateRange];
    const streamName = this.props.selected && this.props.selected.name;
    let result = [];
    _.forEach(comparison, dashboard => {
      _.forEach(dashboard.data, (d, i) => {
        let item = this.convertReportDataItemToComparisonValues(percentile, threshold, d, dashboard);
        result.push(item);
      });
    });

    result = _.groupBy(result, 'month');
    return (
      <div className='report execdashboard comparison'>
        <NoData show={!result && !this.props.loading} />
        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={`/report/${this.props.selected._id}`}>
            Value Stream dashboard
          </Link>
        </div>)}
        {comparisonText && streamName && (
          <div className='comparison-title'>
            <h1>{`Value Stream Performance: ${streamName}`}</h1>
            <p>{comparisonText.subtitle}</p>
          </div>
        )}
        {result && comparisonDates && (
          <React.Fragment>
            <ReportTable
              key="avgCycleTimeReportTable"
              percentile={this.state.percentile}
              changePercentile={this.changePercentile}
              data={result}
              dates={comparisonDates}
              columnLabels={comparisonText && comparisonText.labels}
              dateFormat={this.state.dateFormat}
              columnHeader="Cycle Time"
              fieldName="avgCycleTime"
              positive={true}
              time={true}
              excludeWeekendOpts={this.props.excludeWeekendOpts}
            ></ReportTable>
            <ReportTable
              key="avgThroughputReportTable"
              data={result}
              dates={comparisonDates}
              columnLabels={comparisonText && comparisonText.labels}
              dateFormat={this.state.dateFormat}
              columnHeader="Average Throughput"
              fieldName="avgThroughput"
              positive={false}
            ></ReportTable>
            <ReportTable
              key="wipTrendReportTable"
              data={result}
              dates={comparisonDates}
              columnLabels={comparisonText && comparisonText.labels}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP"
              fieldName="wipTrend"
              positive={true}
            ></ReportTable>
            <ReportTable
              key="awipAgeReportTable"
              data={result}
              dates={comparisonDates}
              columnLabels={comparisonText && comparisonText.labels}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP Age"
              fieldName="wipAge"
              positive={true}
              time={true}
              excludeWeekendOpts={this.props.excludeWeekendOpts}
            ></ReportTable>
            <ReportTable
              key="flowEfficiencyReportTable"
              data={result}
              dates={comparisonDates}
              columnLabels={comparisonText && comparisonText.labels}
              dateFormat={this.state.dateFormat}
              columnHeader="Flow Efficiency"
              fieldName="flowEfficiency"
              positive={false}
            ></ReportTable>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderPercentiles() {
    if (reportHasNoData(this.props.trends, this.props.loading)) {
      return <ChartPlaceholder shape="table" />;
    }
    return (
      <div className='percentile-progression'>
        {this.props.stats.avgPercentiles &&
          this.props.stats.avgPercentiles.map((p, i) => {
            return (
              <div key={i}>
                <h4>
                  {formatWorkDuration(p.value, this.props.excludeWeekendOpts, 'd[d] h[h] m[m]')}
                </h4>
                <p>{p.text}th percentile</p>
              </div>
            );
          })}
      </div>
    );
  }
  renderButtons() {
    const { user, selected, loading } = this.props;
    const access = getStreamAccessRights(user, selected);
    const canCreateStreams = user && user.permissions && user.permissions.createStreams;

    return [
      <SubscribeEDAddOn key="subscribe" />,
      canCreateStreams && <DropdownButton
        key="create-dropdown"
        id="create-dropdown"
        variant='secondary'
        size='sm'
        title={
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip-create-stream" className='tooltip_dark'>Create value stream</Tooltip>}
          >
            <img src={createIcon} alt="" />
          </OverlayTrigger>
        }
        >
        <li>
          <Button onClick={this.handleNew} className='btn'>
            <span className="title"><img src={createIcon} alt="#"/> Create value stream</span>
            <span className="help-text">
              Select the team dashboards you want to include and visualize your end-to-end delivery flow.
            </span>
          </Button>
        </li>
      </DropdownButton>,

      selected && (
        <DropdownButton
          disabled = {loading}
          key="stream-settings"
          id="stream-settings"
          size='sm'
          variant='secondary'
          title={
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-settings" className='tooltip_dark'>
                  Value Stream settings
                </Tooltip>
              }
            >
              <img src={settingsIcon} alt="" />
            </OverlayTrigger>
          }
        >
          {this.state.comparison ? (
            <li key="pdf-export">
              <Button onClick={this.handlePdfExport}>
                <span className="title">
                  <img src={exportIcon} alt="Export"/> Export PDF report
                </span>
                <span className="help-text">
                  Generate a PDF report of your value stream for easy sharing and presentation.
                </span>
              </Button>
            </li>
          ) : (
            <React.Fragment>
              <li key="csv-export">
                <Button onClick={this.handleCsvExport}>
                  <span className="title">
                    <img src={cloudDownload} alt="Export"/> Export value stream data
                  </span>
                  <span className="help-text">
                    Export your value stream data as a CSV file to create custom reports.
                  </span>
                </Button>
              </li>
              <li key="pdf-export">
                <Button onClick={this.handlePdfExport}>
                  <span className="title">
                    <img src={exportIcon} alt="Export"/> Export PDF report
                  </span>
                  <span className="help-text">
                    Generate a PDF report of your value stream for easy sharing and presentation.
                  </span>
                </Button>
              </li>
            </React.Fragment>
          )}

          {!!access.edit && <li key="edit-stream" onClick={ev => this.handleConfigure(selected)}>
            <div className='btn'>
              <span className="title">
                <img src={editIcon} alt="Edit" /> Edit value stream
              </span>
              <span className="help-text">
                Add or remove team dashboards and update your value stream.
              </span>
            </div>
          </li>}

          {!!access.delete && <li key="delete-stream">
            <Confirm
              onConfirm={ev => this.deleteStream()}
              body={
                <p>
                  Are you sure you want to delete <strong>{selected.name}</strong>?
                </p>
              }
              confirmText="Delete"
              icon={deleteIcon}
              title="Delete value stream"
            >
              <div className='btn'>
                <span className="title red">
                  <img src={deleteIcon} alt="Delete" /> Delete value stream
                </span>
                <span className="help-text">
                  Delete this value stream and its associated data. This action cannot be undone.
                </span>
              </div>
            </Confirm>
          </li>}
        </DropdownButton>
      ),

      selected && (
        <DropdownButton
          disabled = {loading}
          key="views-actions"
          id="views-dropdown"
          size='sm'
          variant='secondary'
          title={<img src={dashboardIcon} alt="Dashboard actions" />}
        >
          {!!access.view && (
            <li key="apply-view">
              <Views>
                <Button>
                  <span className="title"><img src={applyIcon} alt="#" /> Apply value stream view</span>
                  <span className="help-text">
                    Apply a previously saved set of controls and filters to this value stream.
                  </span>
                </Button>
              </Views>
            </li>
          )}
          {!!access.edit && (
            <li key="save-view">
              <SaveView>
                <Button>
                  <span className="title"><img src={saveIcon} alt="#" /> Save current value stream view</span>
                  <span className="help-text">
                    Save the current controls and filters as a value stream view.
                  </span>
                </Button>
              </SaveView>
            </li>
          )}
        </DropdownButton>
      )
    ];
  }

  renderExecutiveReport() {
    const flowEfficiency = !isNaN(this.props.stats.avgFe);
    const noData = reportHasNoData(this.props.trends, this.props.loading);
    const kpi = value => (noData ? <span className="is-empty">No data available</span> : value);
    const { wallmode, filters } = this.props;
    const {
      isFullScreen,
      wp,
      th,
      wat,
      ct,
      fe,
    } = this.state;

    const breakDownItemsCt = getBreakDownList(filters && filters.dashboards, 'cycletime');
    const breakDownItemsTh = getBreakDownList(filters && filters.dashboards, 'throughput');
    const subsetColors = _(this.props.trends && this.props.trends.throughput)
      .map(({ name, color }) => [name, color])
      .fromPairs()
      .value();

    const reportUrl = this.props.selected && this.props.selected._id ? `/report/${this.props.selected._id}?comparison=true` : '/report?comparison=true';
    return (
      <div className='report-wrap execdashboard'>
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={reportUrl}>
            Value Stream Report
          </Link>
          <DatePicker updateValue={wallmode ? null : this.handleDateChange} disableSave />
        </div>)}

        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}

        {/*<NoData show={!this.props.trends.avgCt} />*/}

        {/* the summary (3190 EX 5): the value stream's numbers for the period, in one row */}
        <div className="row-cell-list report-summary report-kpis">
          <div className="cell">
            <div className="cell-header">
              <h4>Avg. cycle time {kpi(<span>{formatWorkDuration(this.props.stats.avgCt, this.props.excludeWeekendOpts, 'd[d] h[h] m[m]')}</span>)}</h4>
            </div>
          </div>
          <div className="cell">
            <div className="cell-header">
              <h4>Throughput {kpi(<span>{this.props.stats.avgThroughput} work items</span>)}</h4>
            </div>
          </div>
          {flowEfficiency && (
            <div className="cell">
              <div className="cell-header">
                <h4>Avg. flow efficiency {kpi(<span>{this.props.stats.avgFe}%</span>)}</h4>
              </div>
            </div>
          )}
        </div>

        <div className="row-cell-list report-summary">
          <div className="cell">
            <div className="cell-header">
              <h4>Avg. cycle time percentiles</h4>
            </div>
            <div className="cell-content">
              {this.renderPercentiles()}
            </div>
          </div>
        </div>

        <h5 className="report-section-title">Trends</h5>
        <div ref={this.trendsGridRef} className="grid-stack row-cell-list">
          <div className="grid-stack-item" gs-w="6" gs-h={`${ct ? 2 : 1}`} style={isFullScreen === 'ctt' ? { zIndex: 9999 } : ct ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-ctb">
            <div className={`cell ${isFullScreen === 'ctt' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.avgCt, this.props.loading) ? 'cell--empty' : ''} ${ ct ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Cycle time</h4>
                <Button variant='flat' size="md" className={ct ? 'active' : ''} onClick={() => this.handleChartExpand('ct', 'card-ctb', 'ctt')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant='flat' size="md" id="fullscreen-ctt" onClick={this.handleResize}>
                  <img src={isFullScreen === 'ctt' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  loading={this.props.loading}
                  id="ct"
                  className="chart"
                  detailed={ct}
                  isFullScreen={isFullScreen === 'ctt'}
                  plural={true}
                  tooltipLabel="Avg. cycle time"
                  unit="day"
                  data={this.props.trends.avgCt}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${th ? 2 : 1}`} style={isFullScreen === 'tht' ? { zIndex: 9999 } : th ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-throughput-trends">
            <div className={`cell ${isFullScreen === 'tht' ? 'fullscreen' : '' } ${cardIsEmpty(this.props.trends.throughput, this.props.loading) ? 'cell--empty' : ''} ${ th ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Throughput trends</h4>
                <Button variant="flat" size="md" className={th ? 'active' : ''} onClick={() => this.handleChartExpand('th', 'card-throughput-trends', 'tht')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-tht" onClick={this.handleResize}>
                  <img src={isFullScreen === 'tht' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  loading={this.props.loading}
                  id="throughput"
                  className="chart"
                  detailed={th}
                  isFullScreen={isFullScreen === 'tht'}
                  plural={true}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.throughput}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wp ? 2 : 1}`} style={isFullScreen === 'wip' ? { zIndex: 9999 } : wp ? {height: 'calc(2 * var(--gs-cell-height))' } : {}} id="card-wip">
            <div className={`cell ${ isFullScreen === 'wip' ? 'fullscreen' : '' } ${cardIsEmpty(this.props.trends.wip, this.props.loading) ? 'cell--empty' : ''} ${ wp ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP</h4>
                <Button variant="flat" size="md" className={wp ? 'active' : ''} onClick={() => this.handleChartExpand('wp', 'card-wip', 'wip')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-wip" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wip' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="wip"
                  className="chart"
                  detailed={wp}
                  isFullScreen={isFullScreen === 'wip'}
                  showExactDate={true}
                  plural={false}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.wip}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wat ? 2 : 1}`} style={isFullScreen === 'wat' ? { zIndex: 9999 } : wat ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-wipAge">
            <div className={`cell ${isFullScreen === 'wat' ? 'fullscreen' : '' } ${cardIsEmpty(this.props.trends.avgWat, this.props.loading) ? 'cell--empty' : ''} ${ wat ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP age</h4>
                <Button variant="flat" size="md" className={wat ? 'active' : ''} onClick={() => this.handleChartExpand('wat', 'card-wipAge', 'wat')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-wat" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wat' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  loading={this.props.loading}
                  id="wat"
                  className="chart"
                  detailed={wat}
                  showExactDate={true}
                  isFullScreen={isFullScreen === 'wat'}
                  plural={true}
                  tooltipLabel="Avg. WIP age time"
                  unit="day"
                  data={this.props.trends.avgWat}
                />
              </div>
            </div>
          </div>
        </div>

        <h5 className="report-section-title">Distribution & composition</h5>
        <div ref={this.distributionGridRef} className="grid-stack row-cell-list">
          <div className="grid-stack-item" gs-w="6" id="card-cycletime">
            <div className="widget">
              <PieChartWidget
                loading={this.props.loading}
                wallmode={this.props.wallmode}
                className="cell cell-33"
                name="cycletime-breakdown"
                title={
                  <React.Fragment>
                    Cycle Time Breakdown
                    <DragIcon customizeMode={this.props.customizeMode} />
                  </React.Fragment>
                }
                formatter={(p) => formatCycletimeLabel(p, this.props.excludeWeekendOpts, this.props.filters.timePrecision)}
                breakdowns={this.props.stats.cycletimeBreakdowns}
                options={breakDownItemsCt}
                colors={subsetColors}
                selected={this.props.filters && this.props.filters.cycletime && this.props.filters.cycletime[0] || (breakDownItemsCt.length > 0 ? breakDownItemsCt[0].id[0] : '')}
                onResize={() => trackExecutiveDashboardView('cycletime-breakdown')}
                onSelect={(field) => this.onBreakdownChange('cycletime', field)}
              />
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" id="card-throughput">
            <div className="widget">
                <PieChartWidget
                  loading={this.props.loading}
                  wallmode={this.props.wallmode}
                  className="cell cell-33"
                  name="throughput-breakdown"
                  title={
                    <React.Fragment>
                      Throughput breakdown
                      <DragIcon customizeMode={this.props.customizeMode} />
                    </React.Fragment>
                  }
                formatter={(p) => formatThroughputLabel(p)}
                breakdowns={this.props.stats.throughputBreakdowns}
                options={breakDownItemsTh}
                colors={subsetColors}
                selected={this.props.filters && this.props.filters.throughput && this.props.filters.throughput[0] || (breakDownItemsTh.length > 0 ? breakDownItemsTh[0].id[0] : '')}
                onResize={() => trackExecutiveDashboardView('throughput-breakdown')}
                onSelect={(field) => this.onBreakdownChange('throughput', field)}
              />
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" id="card-percentile-trends">
            <div className={`cell ${isFullScreen === 'percentile' ? 'fullscreen' : '' } ${cardIsEmpty(this.props.trends.percentiles, this.props.loading) ? 'cell--empty' : ''}`}>
              <div className='cell-header'>
                <h4>Percentiles</h4>
                <Button variant='flat' size="md" id="fullscreen-percentile" onClick={this.handleResize}>
                  <img src={isFullScreen === 'percentile' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <div className={`card-drag ${this.props.customizeMode ? '' : 'hidden'}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 2v20" />
                    <path d="m15 19-3 3-3-3" />
                    <path d="m19 9 3 3-3 3" />
                    <path d="M2 12h20" />
                    <path d="m5 9-3 3 3 3" />
                    <path d="m9 5 3-3 3 3" />
                  </svg>
                </div>
              </div>
              <div className='cell-content'>
                <LineChart
                  loading={this.props.loading}
                  id="percentiles-trend"
                  keepColors
                  className="chart"
                  isFullScreen={isFullScreen === 'percentile'}
                  tooltipLabel=""
                  unit="day"
                  showLegend={isFullScreen === 'percentile'}
                  legendSuffix="%"
                  data={this.props.trends.percentiles}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${fe ? 2 : 1}`} style={isFullScreen === 'fe' ? { zIndex: 9999 } : fe ? { height: 'calc(2 * var(--gs-cell-height))' } : {}} id="card-flow-efficiency">
            <div className={`cell ${isFullScreen === 'fe' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.flowEfficiency, this.props.loading) ? 'cell--empty' : ''} ${ fe ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Flow Efficiency</h4>
                <Button variant="flat" size="md" className={fe ? 'active' : ''} onClick={() => this.handleChartExpand('fe', 'card-flow-efficiency', 'fe')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-fe" onClick={this.handleResize}>
                  <img src={isFullScreen === 'fe' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <div className={`card-drag ${this.props.customizeMode ? '' : 'hidden'}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 2v20" />
                    <path d="m15 19-3 3-3-3" />
                    <path d="m19 9 3 3-3 3" />
                    <path d="M2 12h20" />
                    <path d="m5 9-3 3 3 3" />
                    <path d="m9 5 3-3 3 3" />
                  </svg>
                </div>
              </div>
              <div className='cell-content'>
                <LineChart
                  loading={this.props.loading}
                  id="fe"
                  className="chart"
                  detailed={fe}
                  isFullScreen={isFullScreen === 'fe'}
                  tooltipLabel="Avg. flow efficiency"
                  unit="%"
                  data={this.props.trends.flowEfficiency}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  trialExpired(){
    return !this.props.user.config || moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0 || !this.props.user.config.exportEnabled;
  }

  render() {
    const { wallmode, filters, dateRange, user, selected } = this.props;
    const trialExpired = this.trialExpired();
    const access = getStreamAccessRights(user, selected);
    const canFilter = !wallmode && !!(access && access.edit);
    return [
      !trialExpired && <ValueStreamSelector key="1" title="" buttons={wallmode ? null : this.renderButtons()} showTeam={true} hasFilterPanel={canFilter}
        items={this.props.streams}
        selectedItem={this.props.selectedStream}
        onSelect={this.props.selectStream}
        onSaveSelected={this.props.saveSelectedStream}
        onListAll={this.props.listAllStreams}
        loaded = {this.props.loaded}
        noItems={this.props.noStreams}
        basePath="/report"
        emptyPath="/no-streams"
        searchPlaceholder="Search Value Stream"
        defaultItemImage={defaultBoardImg}
        defaultItemIdFromUserConfigKey="selectedValueStream"
        dataIsLoading={this.props.loading}
        showTeamInHeader={true}
      />,
      !trialExpired && <div key="2" id="executive" className='content-wrap'>
        <Helmet>
          <title>{pageTitle('Value Streams')}</title>
        </Helmet>  
        {canFilter && (
          <Filter loading = {this.props.loading}
            threshold={this.state.threshold}
            changeThreshold={this.changeThreshold}
            dateRange={dateRange}
            changeDateRange={this.changeDateRange}
            controls={this.state.comparison}
            onApply={this.applyFilters}
            dashboards={filters.dashboards || []}
            user={this.props.user}
            saveFilterSize={this.props.saveFilterSize}
          />
        )}
        {this.state.comparison ? this.renderComparisonReport() : this.renderExecutiveReport()}
      </div>,
      trialExpired &&
      <div className='main expired' key="3">
        <Header showTeam={true} buttons={<SubscribeEDAddOn></SubscribeEDAddOn>}/>
        <div className='centerContent'>
          <div>
            <h1 className='title'>Your trial has expired</h1></div>
          </div>
        </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err)),
    getFilters: id => dispatch(getFilters(id)),
    setFilters: (id, data, returnData) => dispatch(setFilters(id, data, returnData)),
    requestData: id => dispatch(requestData(id)),
    requestComparisonData: (page, id) => dispatch(requestComparisonData(page, id)),
    getComparisonPdf: (percentile, threshold, id) => dispatch(getComparisonPdf(percentile, threshold, id)),
    getPdf: (id) => dispatch(getPdf(id)),
    getCsv: (id) => dispatch(getCsv(id)),
    select: (itemId, viewId) => dispatch(selectStream(itemId, viewId)),
    remove: (id) => dispatch(deleteStream(id)),
    listAllStreams: () => dispatch(listAll()),
    selectStream: (item, viewId) => dispatch(selectStream(item, viewId)),
    saveSelectedStream: (id) => dispatch(saveSelected(id)),
    saveSelectedBreakdown: (id, chart, value) => dispatch(saveSelectedBreakdown(id, chart, value)),
    saveSelectedDateRange: (id, dateRange) => dispatch(saveSelectedDateRange(id, dateRange)),
    saveFilterSize: size => dispatch(saveFilterSize(size))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    wallmode: state.app.wallmode,
    selected: state.report.selectedStream,
    filters: state.report.filters,
    dateRange: state.report.dateRange,
    loading: state.report.isLoading,
    comparisons: state.report.comparisons,
    stats: state.report.stats,
    trends: state.report.trends,
    streams: state.report.streams,
    selectedStream: state.report.selectedStream,
    noStreams: state.report.noStreams,
    loaded: state.report.loaded,
    user: state.auth.user,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports));
export { Reports };
